import type { MentorBookmark } from "../../../shared/bookmarkTypes";
import type { Mentor, MentorPanel } from "../../../shared/mentorTypes";
import Card from "../../Cards/Card";
import PanelCard from "../../Cards/PanelCard";
import styles from "./MentorGrid.module.css";

export default function MentorGrid({
  panels,
  mentors,
  bookmarkedMentors,
}: {
  panels: MentorPanel[];
  mentors: Mentor[];
  bookmarkedMentors: MentorBookmark[];
}) {
  return (
    <div>
      <div className={styles.sectionLinks}>
        <a href="#mentor-panels">Mentor Panels</a>
        <a href="#individual-mentors">Individual Mentors</a>
      </div>

      <div className={styles.mentorGrid}>
        <div
          className={styles.mentorPanels}
          id="mentor-panels"
          data-cy="mentor-panels"
        >
          {panels.map((card) => (
            <PanelCard
              key={card._id}
              mentorPanel={card}
              dataCy={"mentor-panel-card-" + card._id}
            />
          ))}
        </div>

        <div
          className={styles.mentorCards}
          id="individual-mentors"
          data-cy="individual-mentors"
        >
          {mentors.map((mentor) => (
            <Card
              key={mentor._id}
              mentor={mentor}
              isBookmarked={bookmarkedMentors
                .map((b) => b.mentorId)
                .includes(mentor._id)}
              dataCy={"mentor-card-" + mentor._id}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
